var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('iframe',{attrs:{"id":"levelMap","title":"GIS MAP","width":"100%","height":"88%","src":"./static/gis/level_map.html"},on:{"load":_vm.load}})}
var staticRenderFns = []

export { render, staticRenderFns }